import {Action, Icon} from '@sail/ui';
import {cancel} from '@sail/icons/react/Icon';
import {NetworkSelector} from 'src/v2/components/walletConnect/NetworkSelector';
import {WalletCard} from 'src/v2/components/wallet/WalletCard';
import {WalletConnectionPendingOverlay} from 'src/v2/components/walletConnect/WalletConnectionPendingOverlay';
import {WalletConnectQrCode} from 'src/v2/components/walletConnect/WalletConnectQrCode';
import {useIsWalletConnecting} from 'src/v2/components/walletConnect/useIsWalletConnecting';
import {getStore} from 'src/v2/state/store';
import {ErrorBanner} from 'src/v2/components/error/ErrorBanner';
import {isMobile} from 'src/utils/utils';

export const WalletConnectScreen = () => {
  const {startWalletConnection, isWalletConnecting} = useIsWalletConnecting();
  const store = getStore();
  const newWallet = store.useSelector((state) => state.newWallet);

  if (!newWallet) {
    throw new Error('newWallet is required in WalletConnectScreen');
  }

  return (
    <>
      <WalletCard
        wallet={{
          option: newWallet.walletOption,
        }}
        headerActions={
          <Action
            onPress={() => {
              store.setValue((state) => {
                state.screen = 'WALLET_SELECT';
              });
            }}
          >
            <Icon icon={cancel} size="xsmall" />
          </Action>
        }
        bottomContent={
          newWallet.walletOption.provider === 'WalletConnect' && !isMobile() ? (
            <WalletConnectQrCode />
          ) : (
            <NetworkSelector startWalletConnection={startWalletConnection} />
          )
        }
      />
      <ErrorBanner />
      {isWalletConnecting ? <WalletConnectionPendingOverlay /> : null}
    </>
  );
};
